import {createSvgIcon} from '../create-svg-icon';

export const KeyboardDoubleArrowUpIcon = createSvgIcon(
  [<path d="M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z" key="0" />,<path d="m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z" key="1" />,]
, 'KeyboardDoubleArrowUpOutlined');
